import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'

import { useRouter } from 'next/router'

import { STATUS } from 'helpers/spa'

const PreloadContext = createContext({ status: STATUS.idle, startPreloading: () => {}, stopPreloading: () => {} })

export const usePreload = () => useContext(PreloadContext)

export const PreloadProvider = ({ children }) => {
  const [status, setStatus] = useState(STATUS.idle)
  const router = useRouter()

  const startPreloading = useCallback(() => {
    setStatus(() => STATUS.loading)
  }, [setStatus])
  const stopPreloading = useCallback(() => {
    setStatus(() => STATUS.idle)
  }, [setStatus])

  useEffect(() => {
    router.events.on('routeChangeStart', startPreloading)
    router.events.on('routeChangeComplete', stopPreloading)

    return () => {
      router.events.off('routeChangeStart', startPreloading)
      router.events.off('routeChangeComplete', stopPreloading)
    }
  }, [router, startPreloading, stopPreloading])

  return (
    <PreloadContext.Provider value={{ status, startPreloading, stopPreloading }}>{children}</PreloadContext.Provider>
  )
}
